// removed by extract-text-webpack-plugin
module.exports = {"wishListCatalogWrap":"qempo_WishListCatalog_wishListCatalogWrap-2JWykZf","wishListCatalogSubtitle":"qempo_WishListCatalog_wishListCatalogSubtitle-2coxOgJ","blackFriday":"qempo_WishListCatalog_blackFriday-Y3SsK6-","loading":"qempo_WishListCatalog_loading-3oMIWN3"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/wish-list-catalog/components/WishListCatalog/WishListCatalog.scss
// module id = 2161
// module chunks = 0